import { MediaModel } from "@/database";
import { toast } from "../components";

export const handleDownloadMedia = (media?: any, getTokenForDownload?: any) => {
  if (media?.damid) {
    getTokenForDownload({ id: media?.damid || "" })
      .then((res: any) => {
        if (res.status === 200) {
          window.open(
            `${process.env.NX_APP_DOWNLOAD_URL ?? ""}/download?token=${
              res?.data
            }`,
            "_blank"
          );
        }
      })
      .catch(() => {
        toast.fail("Error in download operation");
      });
  } else {
    toast.fail("Cannot download this media");
  }
};

export const generateBaseUrl = (media: MediaModel) => {
  let baseUrl = media?.images?.base;

  // if (!baseUrl && media?.baseurl) {
  //   baseUrl = media?.baseurl;
  // }

  if (!baseUrl && media?.cdn) {
    baseUrl = media?.cdn[0].base;
  }

  if (baseUrl) {
    if (!baseUrl?.endsWith("/")) {
      baseUrl += "/";
    }
  }
  // if (!baseUrl) {
  //   const id = media?.damid ?? media.id;
  //   const url = `/${id?.substring(2, 4)}/${id?.substring(4, 6)}/${id}/`;
  //   baseUrl = `${process.env.NX_APP_MEDIA_BASE ?? ''}${url}`;
  // }
  return baseUrl;
};

// export const getThumbnailUrlUtil = (Media?: any, id?: string, source?: string, separator: string = '/') => {
//   return (
//     `${generateBaseUrl(Media || ({} as MediaModel))}${separator}${id}${
//       source === CONST_SOURCE_MAPPER ? '.jpg' : '_180.jpg'
//     }` || ''
//   );
// };
interface GetThumbnailUrlOptions {
  media?: any;
  id?: string;
  source?: string;
  separator?: string;
  baseUrl?: string;
  sizeSuffix?: string;
}
// YouTube requires thumbnails to be at least 640×360 px
const YOUTUBE_THUMB_MIN_WIDTH = 640;
const YOUTUBE_THUMB_MIN_HEIGHT = 360;

/**
 * Checks whether a thumbnail URL meets YouTube's minimum dimension requirements.
 * Resolves with an error string if dimensions are too small, or null if they are valid.
 * Pass the full-size URL (not the _180.jpg preview) for accurate results.
 */
export const checkYoutubeThumbnailDimensions = (
  url: string
): Promise<string | null> => {
  return new Promise((resolve) => {
    if (!url) {
      resolve(null);
      return;
    }

    const img = new Image();
    img.src = url;

    img.onload = () => {
      if (
        img.naturalWidth < YOUTUBE_THUMB_MIN_WIDTH ||
        img.naturalHeight < YOUTUBE_THUMB_MIN_HEIGHT
      ) {
        resolve(
          `Thumbnail dimensions (${img.naturalWidth}×${img.naturalHeight}) are too small. YouTube requires at least ${YOUTUBE_THUMB_MIN_WIDTH}×${YOUTUBE_THUMB_MIN_HEIGHT} px.`
        );
      } else {
        resolve(null);
      }
    };

    img.onerror = () => resolve(null);
  });
};

export const getThumbnailUrlUtil = (options: GetThumbnailUrlOptions) => {
  const { media, id, separator = "/", baseUrl, sizeSuffix = "" } = options;

  const finalBaseUrl = baseUrl || generateBaseUrl(media || ({} as MediaModel));
  // Return empty string if baseUrl is missing
  if (!finalBaseUrl) {
    return "";
  }

  return `${finalBaseUrl}${separator}${id}${sizeSuffix}.jpg` || "";
};
